import React from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../../redux/store";
import { useTheme } from "@mui/material/styles"; // Import per accedere al tema
import { UtenteLogged } from "../../authentication/authenticationSlice";
import {
	ErrorStatusTypes,
	ErrorsStack,
	parseErrorMessage,
} from "../../common/errorsDeclarations";
import SignIn from "../../authentication/SignIn";
import CircularProgress from "@mui/material/CircularProgress";

import home_img from "../../../../static/images/common/hero-Everest.png";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";

import HomeMenu from "./HomeMenu";
import {EsempioStandalone} from "../../common/comuni/RicercaComune";
import {EsempioConReactHookForm,} from "../../common/comuni/EsempioForm";
import BudgetCommercialePieChart from "../../main/pianificazione/budgets/BudgetCommercialePieChart";
import BudgetTecnicaBarChart from "../pianificazione/budgets/BudgetTecnicaBarChart";
import BudgetMandatarioBarChart from "../pianificazione/budgets/BudgetMandatarioBarChart";


const HomePage = () => {
	const utente = useSelector<RootState, UtenteLogged>(
		(state) => state.authentication.utenteLogged
	);
    const theme = useTheme(); // 1. Hook per il tema

    // Funzione semplice per estrarre il nome del font
    const getFontName = (variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2' | 'button' | 'caption' | 'subtitle1' | 'subtitle2'): string => {
        let fontFamily: string = theme.typography.fontFamily as string;

        // Se c'è una variante specifica, prova a usarla
        if (variant) {
            const variantStyle = theme.typography[variant];
            if (variantStyle && typeof variantStyle === 'object' && 'fontFamily' in variantStyle) {
                fontFamily = variantStyle.fontFamily as string;
            }
        }

        // Estrai solo il primo font (rimuovi virgolette e prendi solo il primo nome)
        return fontFamily.replace(/['"]/g, '').split(',')[0].trim();
    };

	return (
        <Box sx={{ p: 2 }}>
            {/* Riga grafici - stessa altezza */}




            {/* HomeMenu centrato sotto i grafici */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                {utente.errorsStack.status == ErrorStatusTypes.PENDING ? (
                    <CircularProgress size={100} color="info" />
                ) : utente.isLogged ? (

                    <Grid
                        container
                        spacing={2}
                        sx={{
                            alignItems: 'stretch',
                            mb: 3
                        }}
                    >
                        <Grid
                            size={{xs: 12, md: 12}}
                            sx={{display: 'flex'}}
                        >
                            <HomeMenu/>
                        </Grid>
                            <Grid
                                size={{ xs: 12, md: 6 }}
                                sx={{ display: 'flex' }}
                            >
                                <Box sx={{ width: '100%', display: 'flex' }}>
                                    <BudgetTecnicaBarChart />
                                </Box>
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 6 }}
                                sx={{ display: 'flex' }}
                            >
                                <Box sx={{ width: '100%', display: 'flex' }}>
                                    <BudgetMandatarioBarChart />

                                </Box>
                            </Grid>
                            {/*<Grid*/}
                            {/*    size={{ xs: 12, md: 6 }}*/}
                            {/*    sx={{ display: 'flex' }}*/}
                            {/*>*/}
                            {/*    <Box sx={{ width: '100%', display: 'flex' }}>*/}
                            {/*        <BudgetCommercialePieChart />*/}
                            {/*    </Box>*/}
                            {/*</Grid>*/}
                        </Grid>


                ) : (
                    <SignIn />
                )}
            </Box>

        </Box>
	);
};

export default HomePage;
